<nav class="navbar navbar-expand-lg navbar-dark bg-primary shadow">
  <div class="container-fluid">
    <a class="navbar-brand fw-bold" href="#"> Home</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-between" id="navbarNav">

      <!-- سمت راست (آیتم‌های اصلی) -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link active" routerLink="/home">خانه</a>
        </li>

        <li class="nav-item" *ngIf="isAdmin">
          <a class="nav-link" routerLink="/users">کاربران</a>
        </li>

        <li class="nav-item" *ngIf="isAdmin">
          <a class="nav-link" routerLink="/anything">مطالب</a>
        </li>

        <li class="nav-item" *ngIf="isAdmin">
          <a class="nav-link" routerLink="/weblog">وبلاگ</a>
        </li>

        <li class="nav-item" *ngIf="isAdmin || isEditor">
          <a class="nav-link" routerLink="/todo">کارها</a>
        </li>
        <li class="nav-item" *ngIf="isAdmin || isEditor">
          <a class="nav-link" routerLink="/cook">آشپزی</a>
        </li>
        <li class="nav-item" *ngIf="isAdmin || isEditor">
          <a class="nav-link" routerLink="/musicu">متن ترانه</a>
        </li>
        <li class="nav-item" *ngIf="isAdmin">
          <a class="nav-link" routerLink="/command">command </a>
        </li>
        <li class="nav-item" *ngIf="isAdmin || isEditor">
          <a class="nav-link" routerLink="/buy">خریدها </a>
        </li>
        <li class="nav-item" *ngIf="isAdmin || isEditor">
          <a class="nav-link" routerLink="/website"> لینکستان </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact">تماس با ما</a>
        </li>

         <li class="nav-item" *ngIf="isAdmin">
          <a class="nav-link" routerLink="/AdminMessage">دریافت پیام</a>
        </li>


      </ul>

      <!-- سمت چپ (ورود / خروج / ثبت‌نام) -->
      <ul class="navbar-nav">
         <!-- نمایش دکمه ورود و ثبت نام فقط زمانی که کاربر لاگین نیست -->
        <!-- <ng-container *ngIf="!isLoggedIn">
          <li class="nav-item">
            <a class="nav-link" routerLink="/login" routerLinkActive="active">ورود</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/register" routerLinkActive="active">ثبت نام</a>
          </li>
        </ng-container> -->


        <li class="nav-item" *ngIf="isLoggedIn">
          <a class="nav-link" (click)="logout()" style="cursor: pointer;">خروج</a>
        </li>
      </ul>

    </div>
  </div>

  <!-- <app-login *ngIf="!isLoggedIn"></app-login> -->
   <!-- اگر می‌خوای همیشه پایین باشه -->

  <!-- <p>admin: {{ isAdmin }}</p>
<p>logged in: {{ isLoggedIn }}</p> -->


<form class="d-flex align-items-center" *ngIf="!isLoggedIn" (ngSubmit)="login()" style="gap: 5px;">
    <input type="text" class="form-control form-control-sm" placeholder="نام کاربری" [(ngModel)]="model.username"
        name="username" required style="width: 110px;">

    <input type="password" class="form-control form-control-sm" placeholder="رمز عبور" [(ngModel)]="model.password"
        name="password" required style="width: 110px;">

    <button class="btn btn-light btn-sm" type="submit">ورود</button>
    <a class="btn btn-light btn-sm" routerLink="/register">ثبت‌نام</a>

</form>

</nav>
